<template>
  <div class="private-layout">
    <div class="app-wrapper">
      <SideMenu />
      <div id="main-app" class="position-relative">
        <AppHeader />
        <NavBar class="d-block d-md-none" />

        <vue-page-transition name="fade" class="lg-marg-top">
          <slot />
        </vue-page-transition>
      </div>

      <MobileNavBar />
      <!-- <AppFooter /> -->
      <slideout-panel></slideout-panel>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import AppHeader from "@/components/navigation/AppHeader";
// import AppFooter from "@/components/navigation/AppFooter";
import NavBar from "@/components/navigation/NavBar";
import MobileNavBar from "@/components/navigation/MobileNavBar";
import SideMenu from "@/components/navigation/SideMenu";

export default {
  name: "private-layout",
  data() {
    return {
      bgColor: "#778899",
      position: "bottom-right"
    };
  },
  components: {
    AppHeader,
    NavBar,
    MobileNavBar,
    // AppFooter,
    SideMenu
  },
  computed: {
    ...mapState(["userObj"])
  },
  methods: {
    ...mapActions("auth", ["getUserInfo"])
  },
   created() {
    // await this.getUserInfo();
    const completeProfile =
      this.userObj.emailverified && this.userObj.phonenumberverified;
    if (!completeProfile) {
      this.$router.replace({ name: "onboarding" });
    }

    //Drift Oncfig
    // const self = this;
    // setTimeout(() => {
    //   self.$drift.hide();
    // }, 3000);

    // this.$drift.identify(this.userObj.referralcode, {
    //   name: this.userObj.lastname + " " + this.userObj.firstname,
    //   email: this.userObj.email
    // });
  }
};
</script>

<style lang="scss">
.app-wrapper {
  min-height: 100vh;
}

.private-layout {
  position:relative;
  z-index:1
}

.private-layout::after {
  content: "";
  opacity:2;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  position: absolute;
  z-index: -1;
  background-image: url('~@/assets/images/bg.png');
}


#action-fab {
  transition: all 0.3s ease;
}

// Testing Fab Animation TODO: change later
.dashboard-page {
  #action-fab {
    bottom: 100px;
    right: 100px;
  }
}

.savings-page {
  #action-fab {
    bottom: 150px;
    right: 90px;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

@media (min-width: 768px) {
  .lg-marg-top {
    margin-top: 70px
  }

  }
</style>
